import { render, staticRenderFns } from "./floatButton.vue?vue&type=template&id=0b1fc320&scoped=true"
import script from "./floatButton.vue?vue&type=script&lang=js"
export * from "./floatButton.vue?vue&type=script&lang=js"
import style0 from "./floatButton.vue?vue&type=style&index=0&id=0b1fc320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.96.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1fc320",
  null
  
)

export default component.exports